import { render, staticRenderFns } from "./EditorHeaderDesktop.vue?vue&type=template&id=8ec7a4fe&scoped=true&"
import script from "./EditorHeaderDesktop.vue?vue&type=script&lang=ts&"
export * from "./EditorHeaderDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./EditorHeaderDesktop.vue?vue&type=style&index=0&id=8ec7a4fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec7a4fe",
  null
  
)

export default component.exports